import { render, staticRenderFns } from "./PuzzlesItem.vue?vue&type=template&id=678b2e13&scoped=true"
import script from "./PuzzlesItem.vue?vue&type=script&lang=js"
export * from "./PuzzlesItem.vue?vue&type=script&lang=js"
import style0 from "./PuzzlesItem.vue?vue&type=style&index=0&id=678b2e13&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678b2e13",
  null
  
)

export default component.exports